import {ActionItemSkeleton} from './ActionItemSkeleton'
import {ActionItemsList} from './ActionItemsList'

export function ActionItemsLoading() {
  return (
    <ActionItemsList>
      <ActionItemSkeleton />
    </ActionItemsList>
  )
}
